import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const emptyBilling = {
  givenName: "", familyName: "", email: "", streetAndNumber: "", postalCode: "", city: "", country: "DE",
};

const Field = ({ id, label, value, onChange, placeholder, type = "text", testid }) => (
  <div className="space-y-1.5">
    <Label htmlFor={id} className="text-sm text-stone-600">{label}</Label>
    <Input id={id} type={type} value={value} placeholder={placeholder} data-testid={testid}
      onChange={(e) => onChange(e.target.value)} className="h-12 rounded-xl" />
  </div>
);

export function BillingFields({ value, onChange }) {
  const set = (k) => (v) => onChange({ ...value, [k]: v });
  return (
    <div className="space-y-4">
      <div className="grid sm:grid-cols-2 gap-4">
        <Field id="b-given" label="Vorname" value={value.givenName} onChange={set("givenName")} testid="billing-givenName" />
        <Field id="b-family" label="Nachname" value={value.familyName} onChange={set("familyName")} testid="billing-familyName" />
      </div>
      <Field id="b-email" label="Rechnungs-E-Mail" type="email" value={value.email} onChange={set("email")}
        placeholder="rechnung@praxis.de" testid="billing-email" />
      <Field id="b-street" label="Straße & Hausnummer" value={value.streetAndNumber} onChange={set("streetAndNumber")} testid="billing-street" />
      <div className="grid sm:grid-cols-3 gap-4">
        <Field id="b-zip" label="PLZ" value={value.postalCode} onChange={set("postalCode")} testid="billing-zip" />
        <div className="sm:col-span-2">
          <Field id="b-city" label="Ort" value={value.city} onChange={set("city")} testid="billing-city" />
        </div>
      </div>
    </div>
  );
}

export function billingValid(b) {
  return ["givenName", "familyName", "email", "streetAndNumber", "postalCode", "city"].every(
    (k) => (b[k] || "").trim().length > 0,
  ) && /\S+@\S+\.\S+/.test(b.email);
}
